import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import {
  FeedbackAndQuestionNoticeCreate,
  FeedbackAndQuestionNoticeResponse,
  feedbackAndQuestionNoticeResponseSchema,
} from '../../../common/validations/feedbackAndQuestionNotice'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { ResidentAppError } from '../../../common/error'
import { ErrorResponse } from '../../../common/validations'
import { isFeatureAccessDenied } from '../../utils/isFeatureAccessDenied'

import { post } from 'api/apiClient'

export const useAPIPostQuestion = (
  options?: UseMutationOptions<
    FeedbackAndQuestionNoticeResponse,
    ErrorResponse,
    FeedbackAndQuestionNoticeCreate
  >
) => {
  const { isError, isPending, mutate } = useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.CREATE_QUESTION,
        data,
        feedbackAndQuestionNoticeResponseSchema
      ),
    retry: 1,
    throwOnError: isFeatureAccessDenied,
    ...options,
  })

  if (isError) {
    throw ResidentAppError.ClientError('QUESTION_SUBMIT_ERROR')
  }

  return {
    submit: mutate,
    isSubmitting: isPending,
  }
}
